(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  if (document.querySelector('#amzn-bwp-cart')) {
    const loader = new ScriptLoader();
    loader.load(['//code.buywithprime.amazon.com/bwp.v1.js']).then(({ length }) => {
      console.log(`${length} scripts loaded!`);
    });
  }

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      window.matchMedia('(max-width: 767px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      // document.querySelector('.header-wrapper').classList.contains('bg-transparent').querySelector('header').style.setProperty('margin-bottom', `-${this.header.offsetHeight}px`);
      // Select the element with class 'header-wrapper'
      const headerWrapper = document.querySelector('.header-wrapper');

      // Check if the element has the class 'bg-transparent'
      if (headerWrapper && headerWrapper.classList.contains('bg-transparent')) {
        // Select the header element within the headerWrapper
        const mainContent = document.querySelector('#MainContent');

        if (mainContent) {
          // Set the margin-bottom property of the header
          // mainContent.style.setProperty('margin-top', `-${this.header.offsetHeight}px`);
          document.body.style.setProperty('--margin-top', `${this.header.offsetHeight}px`);
        }
      }
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        document.body.classList.add('body-scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        document.body.classList.remove('body-scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('sticky-header-shown');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.remove('sticky-header-shown');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      document.body.classList.remove('sticky-header-shown');
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  document.addEventListener('DOMContentLoaded', () => {
    let dropdownList = document.querySelectorAll('.m-dropdown-menu');

    dropdownList.forEach((dropdown) => {
      dropdown.classList.remove('d-none');
      document.getElementById('hasMegaMenu')?.classList.add('nav-is-ready');
    });

    let megaMenuList = document.querySelectorAll('.mega-menu');

    if (megaMenuList.length > 0) {
      megaMenuList.forEach((megaMenu) => {
        megaMenu.addEventListener('mouseenter', function checkHover() {
          megaMenu.querySelectorAll('video').forEach((video) => {
            if (!video.playing) {
              video.play();
            }
          });
        });
      });
    }

    // megaMenu();
  });
  // Mega Menu Accessibility
  document.addEventListener('DOMContentLoaded', () => {
    const triggers = document.querySelectorAll('.header__menu-li-js [aria-haspopup="true"]');

    if (!triggers.length) return;

    const FOCUSABLE_SELECTOR = 'a, button, [tabindex]:not([tabindex="-1"])';
    const headerWrapper = document.querySelector('.jm-header-wrapper');

    let headerHasFocus = false;

    // Track focus inside the header
    if (headerWrapper) {
      headerWrapper.addEventListener('focusin', () => {
        headerHasFocus = true;
        updateHeaderBackground();
      });

      headerWrapper.addEventListener('focusout', () => {
        setTimeout(() => {
          headerHasFocus = headerWrapper.contains(document.activeElement);
          updateHeaderBackground();
        }, 0);
      });
    }

    function updateHeaderBackground() {
      const anyMenuOpen = Array.from(triggers).some((t) => t.getAttribute('aria-expanded') === 'true');
    }

    triggers.forEach((trigger) => {
      const menuId = trigger.getAttribute('aria-controls');
      const menu = document.getElementById(menuId);
      if (!menu) return;

      const li = trigger.closest('.header__menu-li-js');
      let suppressFocusOpen = false;

      function setFocusable(disabled) {
        menu.querySelectorAll(FOCUSABLE_SELECTOR).forEach((el) => {
          if (disabled) {
            el.setAttribute('tabindex', '-1');
            el.setAttribute('data-tab-disabled', 'true');
          } else if (el.hasAttribute('data-tab-disabled')) {
            el.removeAttribute('tabindex');
            el.removeAttribute('data-tab-disabled');
          }
        });
      }

      function toggleMenu(open) {
        trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
        menu.setAttribute('aria-hidden', open ? 'false' : 'true');
        setFocusable(!open);
        updateHeaderBackground();
      }

      // Start closed
      toggleMenu(false);

      // Open menu when trigger receives focus (via Tab)
      trigger.addEventListener('focus', () => {
        if (suppressFocusOpen) {
          suppressFocusOpen = false;
          return;
        }
        toggleMenu(true);
      });

      // Mouse: hover open/close
      li.addEventListener('mouseenter', () => toggleMenu(true));
      li.addEventListener('mouseleave', () => toggleMenu(false));

      function isEsc(event) {
        return event.key === 'Escape' || event.key === 'Esc' || event.keyCode === 27;
      }

      // Esc anywhere inside this li
      li.addEventListener('keydown', (event) => {
        if (!isEsc(event)) return;

        const isOpen = trigger.getAttribute('aria-expanded') === 'true';
        if (!isOpen) return;

        event.preventDefault();
        event.stopPropagation();

        suppressFocusOpen = true;
        toggleMenu(false);
        trigger.focus();
      });

      // Auto-close when focus leaves the entire li
      li.addEventListener('focusout', () => {
        setTimeout(() => {
          const active = document.activeElement;
          if (!li.contains(active)) {
            suppressFocusOpen = false;
            toggleMenu(false);
          }
        }, 0);
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
